import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  // The default values are [0, 600, 900, 1200, 1536]
  breakpoints: {},

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          fontWeight: 600,
          height: '32px',
          padding: '0px 20px !important',
          textTransform: 'none',
        },
        text: {
          minWidth: 'fit-content !important ',
          p: 0,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: 'grey',
          top: '-6px !important',
        },
      },
    },

    MuiInputBase: {
      styleOverrides: {
        root: {
          height: '36px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          margin: '0px',
          padding: '0px',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 'initial',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        fullWidth: true,
        margin: 'none',
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
        },
      },
    },
  },

  palette: {
    grey: {},
    primary: {
      main: '#248bf8',
    },
    secondary: {
      dark: 'rgb(128, 128, 128)',
      light: 'rgb(223, 227, 232)',
      main: '#0D2840',
    },
  },

  shape: {},

  spacing: 8,

  typography: {
    body1: {
      fontSize: '16px',
      fontWeight: 'inherit',
      lineHeight: '23px',
    },
    body2: {
      fontSize: '14px',
      fontWeight: 'inherit',
      lineHeight: '20px',
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
    caption: {
      fontSize: '12px',
      fontWeight: 'inherit',
      lineHeight: '19.2px',
    },
    h1: {
      fontSize: '30px',
      fontWeight: 'inherit',
      lineHeight: '42px',
    },
    h2: {
      fontSize: '26px',
      fontWeight: 'inherit',
      lineHeight: '36px',
    },
    h3: {
      fontSize: '20px',
      fontWeight: 'inherit',
      lineHeight: '34px',
    },
    h4: {
      fontSize: '18px',
      fontWeight: 'inherit',
      lineHeight: '22px',
    },
  },
})
